import cn from 'classnames';
import { curry } from 'lodash';

const cls = curry((className, props) => ({ ...props, className: cn(className, props.className) }));

export default cls;
